import { render, staticRenderFns } from "./AgentTransferLimit.vue?vue&type=template&id=669eb470&scoped=true"
import script from "./AgentTransferLimit.vue?vue&type=script&lang=js"
export * from "./AgentTransferLimit.vue?vue&type=script&lang=js"
import style0 from "./AgentTransferLimit.vue?vue&type=style&index=0&id=669eb470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669eb470",
  null
  
)

export default component.exports